export default __webpack_public_path__ + "static/media/portal.bba72e00.png";